export const TagsData = [
  { key: "Tag Timeline(for ActivityPub)", value: "#ruste_red" },
  { key: "Stream Commentary", value: "#live_ruste_red" },
  { key: "Fan Art / Cosplay", value: "#pics_ruste_red" },
  { key: "NSFW Arts", value: "#nsfw_ruste_red" },
];

// NOTE 最終的にはソースではなくyamlとかで管理するようにしたい
